import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';
import API from '../services/api.js'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
      storage: window.sessionStorage || null,
  })],
  state:{
    meetings:{},
  },
  modules: {
    auth,
  },
  actions: {
    async getMeetings({ commit,state }) {
      let user_email = state.auth.user.email
      await API.get(`/user/${user_email}/meetings`)
      .then((response) => {
        commit('MeetingSuccess', response.data);
      }).catch(error => console.error(error))
    },
    async updateMeetings({ commit,dispatch,state }) {
      await API.get(`/user/${state.auth.user.email}/update_meetings`)
      .then((response) => {
        if(response.status == 200){
          setTimeout(()=> dispatch('getMeetings'),1000);
        }
      })
    },
    emptyState({commit}){
      commit('emptyState');
    }
  },
  mutations: {
    MeetingSuccess(state, meetings) {
      state.meetings = meetings;
    },
    MeetingUpdSuccess(state,meetings){
      console.log("yes")
    },
    emptyState(state){
      state.meetings = {}
    }
  },
  getters:{
    count_up_meetings: state => {
      return state.meetings.meetings.length
    },
    count_prv_meetings: state => {
      return state.meetings.prv_meetings.length
    },
    count_ins_meetings: state => {
      return state.meetings.instant_meetings.length
    }
  }
});
function isEmpty(obj) {
  for(var prop in obj) {
    if(obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
}